import { network } from 'services/network';

import { QueryParams } from 'api/queries/getResourceTable.query';

export const getResourceTable = (params: QueryParams) => {
    return network.post('api/bo/getResourceTable', params).then((response) => {
        return response.data;
    });
};
